export const isServer = () => {
  return typeof window === 'undefined';
};

export const isString = (value: unknown): value is string => {
  return typeof value === 'string';
};

export const isUndefined = (value: unknown): value is undefined => {
  return typeof value === 'undefined';
};

export const isType = <T>(value: unknown): value is T => {
  return true;
};
